import React from 'react';
import * as Colors from '../../utils/Color';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { Field } from 'react-form';

const styles = {
    radioButton: {
        marginBottom: 0,
        width: "auto",
        marginRight: "25px",
    },
    iconStyle: {
        fill: Colors.primary,
        marginRight: 0
    },
    labelStyle: {
        fontWeight: "bold",
        fontSize: "14px",
        marginLeft: "7px",
        width: "100%"
    },
};

const Radio = props => (
    <Field field={props.field}>
        { fieldApi => {
            const { setValue } = fieldApi;
            return (
                <RadioButtonGroup onChange={ (e, v) => setValue(v) } name={props.field} defaultSelected={props.defaultValue ? props.defaultValue : props.valueFirst } className="radio flex-center-y">
                    <RadioButton
                        label={ props.labelFirst }
                        labelStyle={styles.labelStyle}
                        value={ props.valueFirst }
                        iconStyle={styles.iconStyle}
                        style={styles.radioButton}
                    />
                    <RadioButton
                        label={ props.labelSecond }
                        labelStyle={styles.labelStyle}
                        value={ props.valueSecond }
                        iconStyle={styles.iconStyle}
                        style={styles.radioButton}
                    />
                </RadioButtonGroup>
            );
        }}
    </Field>
);

export default Radio;


// WEBPACK FOOTER //
// ./src/components/UI/Radio.js